
import { Box, Typography } from "@mui/material"
import { Dashboard } from "../dashboard"
import { useIsMobileView } from "../../utils/responsive";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";



export const DashboardPage = () => {
    const isMobileView = useIsMobileView();
    return (
        <Box paddingX={isMobileView ? 2 : 10} marginTop={2} paddingBottom={8}>
            <Typography 
                variant="h4" 
                fontWeight="bold"
                sx={{ 
                    mb: 3,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}
            >
                Dashboard
            </Typography>
        <Dashboard />
    </Box>
)
}